import { blue, green, red } from "@material-ui/core/colors";

export const handleOrderColor = (color='', light=false) => {
  const lowerColor = color.toLowerCase()
  switch (lowerColor) {
    case 'blue':
      return light ? blue[50] : blue[200]
    case 'red':
      return light ?  red[50] : red[200]
    case 'green':
      return light ?  green[50] : green[200]
  
    default:
      break;
  }
}